module.exports = __webpack_public_path__ + "static/media/student.0bc01a84.svg";